import { GET_WEB_PROJECT_SETTINGS_QUERY } from "@core/services/web-project/_queries";
import { query } from "@core/helpers/graphql";

export const get_web_project_settings_query = async (variables, options) => {
    const result = await query(options?.gql || GET_WEB_PROJECT_SETTINGS_QUERY, variables, options);

    return {
        data: options?.gql ? result?.data : result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
}
